/**
 * 데일리 운영 브리핑 — 목 데이터를 쓸지 말지.
 *
 * ─────────────────────────────────────────────────────────────
 * 왜 파일을 따로 뒀나
 * ─────────────────────────────────────────────────────────────
 * 이 판단 하나가 "고객이 가짜 데이터를 본다 / 안 본다"를 가릅니다.
 * opsBriefing.ts 안에 두면 axios 를 끌고 오느라 테스트에서 단독으로
 * 불러올 수가 없어서, 규칙만 떼어 놓고 여기에 테스트를 붙였습니다.
 */

/** 명시적으로 켜거나 끈 경우 — 이게 항상 이깁니다 */
const explicitMock = (): boolean | null => {
    const env = process.env.REACT_APP_USE_OPS_BRIEFING_MOCK;
    if (env === 'true') return true;
    if (env === 'false') return false;

    const saved =
        typeof window !== 'undefined' ? window.localStorage?.getItem('USE_OPS_BRIEFING_MOCK') : null;
    if (saved === 'true') return true;
    if (saved === 'false') return false;

    return null;
};

/**
 * 목 모드는 **배포 빌드에서 꺼진 것이 기본**입니다.
 *
 * 처음에는 반대였습니다 — 목이 기본이고 `.env` 에
 * REACT_APP_USE_OPS_BRIEFING_MOCK=false 를 넣어야 실서버를 봤습니다.
 * 그런데 `.env` 는 gitignore 대상이라 저장소에 적어 둘 수가 없고,
 * 배포하는 사람이 한 번만 빠뜨리면 **모든 고객에게 가짜 회원 이름과
 * 매출이 그대로 나갑니다.** 화면은 멀쩡해 보여서 아무도 모릅니다.
 *
 * 잊었을 때 안전한 쪽이 기본이어야 합니다.
 *   npm start     (development) → 목 ON  — 서버가 안 열려도 화면을 만들 수 있게
 *   npm run build (production)  → 목 OFF — 잊었을 때 안전한 쪽
 *
 * 둘 다 언제든 뒤집을 수 있습니다.
 *   · 빌드 시      REACT_APP_USE_OPS_BRIEFING_MOCK=true | false
 *   · 브라우저에서 localStorage.setItem('USE_OPS_BRIEFING_MOCK', 'true')
 */
export const resolveUseMock = (): boolean =>
    explicitMock() ?? process.env.NODE_ENV === 'development';
